import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IntegrationSettingResponse } from '../models/responses/integration-setting-response';
import { environment } from '../environments/environments';
import { TelegramIntegrationResponse } from '../models/responses/telegram-integration-response';

@Injectable({
  providedIn: 'root'
})
export class TelegramService {

  constructor(private httpClient: HttpClient) { }

  upsertBot(request: { botKey: string, aiAgentId: number }) {
    return this.httpClient.post<TelegramIntegrationResponse>(`${environment.telegramUrl}/addOrUpdateBot`,request);
  }
  deleteBot(id:number) {
    return this.httpClient.delete(`${environment.telegramUrl}/${id}`);
  }
}
